<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="图片名称" prop="title" >
        <a-input v-model="form.title" placeholder="请输入" />
      </a-form-model-item>
      <a-form-model-item label="选择产品" prop="type" >
        <a-radio-group v-model="form.type">
          <a-radio :value="1">直聘</a-radio>
          <a-radio :value="2">推荐</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="图片" prop="imgUrl">
        <a-upload
          :customRequest="fileUploadRequest"
          list-type="picture-card"
          :showUploadList="false"
          :beforeUpload="beforeUpload"
          @change="handleChange">
          <img v-if="form.imgUrl" :src="form.imgUrl" alt="图片" style="height:104px;max-width:300px"/>
          <div v-else>
            <a-icon :type="uploadLoading ? 'loading' : 'plus'"/>
            <div class="ant-upload-text">上传</div>
          </div>
        </a-upload>
        <span style="color:#ff0000">支持JPG、GIF、PNG图片文件 </span>
      </a-form-model-item>
      <a-form-model-item label="链接类型" prop="linkType" >
        <a-select v-model="form.linkType" placeholder="请选择链接类型" @change="changeLinkTypeSelect">
          <a-select-option value="1">
            不跳转
          </a-select-option>
          <a-select-option value="2">
            外链
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="跳转链接" prop="link" v-if="form.linkType == 2">
        <a-input v-model="form.link" placeholder="请输入外链链接" />
      </a-form-model-item>
      <a-form-model-item label="排序" prop="sort" >
        <a-button-group>
          <a-button @click="decline">
            <template><a-icon type="minus" /></template>
          </a-button>
          <a-input @input="validateNumber" type="number" :max-length="5" style="width: 120px" v-model="form.sort"/>
          <a-button @click="increase">
            <template><a-icon type="plus" /></template>
          </a-button>
        </a-button-group>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getBanner, addBanner, updateBanner } from '@/api/user/banner'
import UploadFileToOSS from '@/utils/upload-file-to-oss'
import Editor from '@/components/Editor'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    Editor
  },
  data () {
    return {
      submitLoading: false,
      uploadLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        cateName: null,

        createTime: null,

        remark: null,

        type: 1,

        title: null,

        content: null,

        imgUrl: null,

        linkType: null,

        link: null,

        useFlag: null,

        sort: 0

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        title: [
          { required: true, message: '图片标题', trigger: 'blur' }
        ],
        imgUrl: [
          { required: true, message: '图片地址不能为空', trigger: 'blur' }
        ],
        linkType: [
          { required: true, message: '链接类型 1.不跳转 2.外链不能为空', trigger: 'change' }
        ],
        useFlag: [
          { required: true, message: '是否启用 1-启用 0-不启用不能为空', trigger: 'blur' }
        ],
        sort: [
          { required: true, message: '排序不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    validateNumber(event) {
      // 允许输入数字、小数点、负号
      // 同时设置了type="number"，所以还能防止非数字的输入
      event.target.value = event.target.value.replace(/[^0-9.]+/g, '')
      // 如果有小数点，只保留第一个
      const decimalIndex = event.target.value.indexOf('.')
      if (decimalIndex !== -1) {
        event.target.value = event.target.value.substr(0, decimalIndex) + '.' + event.target.value.substr(decimalIndex).replace(/\./g, '')
      }
      // 如果第一个字符是负号，保证只有当输入有数字时才允许负号
      if (event.target.value[0] === '-' && event.target.value.length > 1) {
        event.target.value = '-' + event.target.value.substr(1).replace(/[^0-9.]+/g, '')
      }
      // 更新数据
      this.form.sort = parseFloat(event.target.value)
    },
    decline() {
      const that = this
      that.form.sort = that.form.sort - 1
      if (that.form.sort < 0) {
        that.form.sort = 0
      }
    },
    increase() {
      const that = this
      that.form.sort = that.form.sort + 1
    },
    handleChange(info) {
      if (info.file.status === 'uploading') {
        this.uploadLoading = true
        return
      }
      if (info.file.status === 'done') {
        this.uploadLoading = false
        this.form.imgUrl = info.file.originFileObj.ossUrl
      }
    },
    fileUploadRequest(fileInfo) {
      this.uploadLoading = true
      new UploadFileToOSS([fileInfo.file], {
        finally: (res) => {
          // Log.info('multi-img-upload', res);
          const ossUrl = res[0].url
          fileInfo.file.ossUrl = ossUrl
          fileInfo.file.ossName = ossUrl
          fileInfo.onSuccess()
        }
      })
    },
    beforeUpload: function (file) {
      return new Promise((resolve, reject) => {
        if (file.size > 5 * 1024 * 1000) {
          this.$message.warning('图片大小不能超过5M')
          return reject(false)
        }

        var fileType = file.type
        if (fileType.indexOf('image') < 0) {
          this.$message.warning('请上传图片')
          return reject(false)
        }
        resolve(true)
      })
    },
    changeLinkTypeSelect(vale) {
      console.log(vale)
      if (vale == 1) {
        this.form.link = null
      } else {
        if (vale == 2) {

        } else {

        }
      }
    },
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        cateName: null,
        createTime: null,
        remark: null,
        type: 1,
        title: null,
        content: null,
        imgUrl: null,
        linkType: null,
        link: null,
        useFlag: null,
        sort: 0
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getBanner({ 'id': id }).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateBanner(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addBanner(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
